import React, {useEffect, useState} from "react";
import styled from '@emotion/styled';

const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  
  height: var(--space-40);
  max-width: 10rem;

  border: 1px solid var(--color-neutral-gray-500);
  box-sizing: border-box;
  border-radius: var(--space-6);
  
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    
    width: 2.5rem;
    height: 100%;
    background: var(--color-neutral-gray-100);
    transition: background-color 0.3s ease-in;
    
    cursor: pointer;
    
    &:hover {
      background: var(--color-neutral-gray-300);
    }
  }
  
  > div.left {
    border-radius: var(--space-6) 0 0 var(--space-6);
  }
  
  > div.right {
    border-radius: 0 var(--space-6) var(--space-6) 0;
  }
  
  > span {
    display: flex;
    align-items: center;
    justify-content: center;
    
    flex-grow: 1;
    
    margin-left: var(--space-12);
    margin-right: var(--space-12);
    width: 3rem;
  
    background: white;
    
    color: var(--color-neutral-gray-900);
    
    font-size: var(--font-16);
    line-height: var(--font-16);
    font-weight: normal;
  }
`;

export default function PaginationComponent({currentPage, pageCount, pageBack, pageNext}) {
    return <PaginationContainer>
        <div className="left" onClick={pageBack}><img src="/icons/chevron_left.svg" alt="page_left"/></div>
        <span>{currentPage} of {pageCount || 1}</span>
        <div className="right" onClick={pageNext}><img src="/icons/chevron_right.svg" alt="page_right"/></div>
    </PaginationContainer>
}
